/* STILL 18.4 · Contact page (sections/nocta-v8-contact.liquid)
   1. "Másolás" copies the e-mail address.
   2. The form is checked before it is sent, with Hungarian messages under the fields
      (the browser's own pop-up bubbles are switched off).
   3. Topic chips: the order number field shows only for the topics that need it, and it is not
      sent when hidden. ?tema=Visszaküldés in the address picks that topic.
   4. Shopify's own errors take the focus; the topic chosen before is picked again.
   5. After sending, the confirmation takes the focus, so screen readers read it at once.
   6. While sending, the button shows a spinner; back from the next page, it works again.
   7. An incomplete form never reaches Shopify's spam protection (which would send it anyway). */
(function () {
  var KEY = 'nx-ct-topic';
  var rx = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var each = function (list, fn) { Array.prototype.forEach.call(list, fn); };

  function copyButtons(root) {
    each(root.querySelectorAll('[data-nx-ct-copy]'), function (b) {
      if (b.__nx) return; b.__nx = true;
      var label = b.querySelector('span'), idle = label.textContent, t = 0;
      b.addEventListener('click', function () {
        var v = b.getAttribute('data-nx-ct-copy');
        var done = function () {
          b.classList.add('is-done'); label.textContent = b.getAttribute('data-done') || idle;
          clearTimeout(t); t = setTimeout(function () { b.classList.remove('is-done'); label.textContent = idle; }, 1800);
        };
        var old = function () {
          var x = document.createElement('textarea'); x.value = v; x.setAttribute('readonly', '');
          x.style.cssText = 'position:fixed;opacity:0;top:0;left:0'; document.body.appendChild(x); x.select();
          try { if (document.execCommand('copy')) done(); } catch (e) {} x.remove();
        };
        if (navigator.clipboard && window.isSecureContext) navigator.clipboard.writeText(v).then(done, old); else old();
      });
    });
  }

  function setup(root) {
    if (root.__nxCt) return; root.__nxCt = true;
    copyButtons(root);
    var MSG = {};
    try { MSG = JSON.parse(root.querySelector('[data-nx-ct-config]').textContent) || {}; } catch (e) {}
    var form = root.querySelector('form');
    if (!form) return;

    var ok = form.querySelector('[data-nx-ct-ok]');
    if (ok) {
      try { sessionStorage.removeItem(KEY); } catch (e) {}
      try { ok.focus({ preventScroll: true }); } catch (e) { ok.focus(); }
      return;
    }
    form.setAttribute('novalidate', '');

    var rules = {
      name: function (v) { return v.trim().length > 1 ? '' : MSG.name; },
      email: function (v) { v = v.trim(); return !v ? MSG.email0 : rx.test(v) ? '' : MSG.email; },
      body: function (v) { return v.trim().length > 2 ? '' : MSG.body; }
    };
    var fields = Array.prototype.slice.call(form.querySelectorAll('[data-nx-ct-v]'));
    function check(el) {
      var rule = rules[el.getAttribute('data-nx-ct-v')], msg = rule ? rule(el.value) || '' : '';
      var out = document.getElementById(el.getAttribute('aria-describedby'));
      el.classList.toggle('is-bad', !!msg);
      el.setAttribute('aria-invalid', msg ? 'true' : 'false');
      if (out) out.textContent = msg;
      return !msg;
    }
    fields.forEach(function (el) {
      el.addEventListener('blur', function () { if (el.value.trim() || el.classList.contains('is-bad')) check(el); });
      el.addEventListener('input', function () { if (el.classList.contains('is-bad')) check(el); });
    });

    var radios = Array.prototype.slice.call(form.querySelectorAll('input[name="contact[Tema]"]'));
    var order = form.querySelector('[data-nx-ct-order]');
    var orderIn = order && order.querySelector('input');
    function sync(animate) {
      if (!order) return;
      var on = radios.some(function (r) { return r.checked && r.hasAttribute('data-order'); });
      var was = !order.hidden;
      order.hidden = !on;
      if (orderIn) orderIn.disabled = !on;
      order.classList.toggle('is-in', on && !was && !!animate);
    }
    function pick(name) {
      if (!name) return false;
      var n = String(name).trim().toLowerCase();
      return radios.some(function (r) { if (r.value.toLowerCase() === n) { r.checked = true; return true; } return false; });
    }
    radios.forEach(function (r) {
      r.addEventListener('change', function () { sync(true); try { sessionStorage.setItem(KEY, r.value); } catch (e) {} });
    });
    var alertBox = form.querySelector('[data-nx-ct-alert]');
    var q = null;
    try { q = new URLSearchParams(location.search).get('tema'); } catch (e) {}
    if (!pick(q) && alertBox) { try { pick(sessionStorage.getItem(KEY)); } catch (e) {} }
    sync(false);
    if (alertBox) { try { alertBox.focus({ preventScroll: true }); } catch (e) {} }

    var btn = form.querySelector('[data-nx-ct-send]');
    var label = btn && btn.querySelector('[data-nx-ct-label]');
    var spin = btn && btn.querySelector('.nx-spin');
    var idle = label ? label.textContent : '', back = 0;
    function rest() {
      if (!btn) return;
      btn.disabled = false;
      if (spin) spin.hidden = true;
      if (label) label.textContent = idle;
    }
    /* Shopify's spam protection (hCaptcha) listens for the submit on the page and sends the form itself,
       whether or not another script stopped it. So the check runs first (window, capture phase), and an
       incomplete form never reaches Shopify's listener. */
    window.addEventListener('submit', function (e) {
      if (e.target !== form) return;
      var bad = fields.filter(function (el) { return !check(el); });
      if (bad.length) { e.preventDefault(); e.stopImmediatePropagation(); bad[0].focus(); return; }
      if (!btn) return;
      setTimeout(function () { btn.disabled = true; }, 0);
      if (spin) spin.hidden = false;
      if (label) label.textContent = btn.getAttribute('data-busy') || idle;
      clearTimeout(back); back = setTimeout(rest, 12000);     // e.g. the hCaptcha window was closed: the button works again
    }, true);
    window.addEventListener('pageshow', function (e) { if (e.persisted) rest(); });
  }

  function all(scope) { each((scope || document).querySelectorAll('[data-nx-ct]'), setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { all(); }); else all();
  document.addEventListener('shopify:section:load', function (e) { all(e.target); });
})();
